import { render, staticRenderFns } from "./my_chat.vue?vue&type=template&id=8adceb92&scoped=true&"
import script from "./my_chat.vue?vue&type=script&lang=ts&"
export * from "./my_chat.vue?vue&type=script&lang=ts&"
import style0 from "./my_chat.vue?vue&type=style&index=0&id=8adceb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adceb92",
  null
  
)

export default component.exports